import { useEffect, useState } from "react";

const navLinks = [
  { href: "#home", label: "首页" },
  { href: "#access", label: "访问入口" },
  { href: "#webapp", label: "网页版·APP" },
  { href: "#popular", label: "番剧推荐" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 h-16 md:h-18">
        <a href="#home" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-sun-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl md:text-2xl tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            动漫之家
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-50/90 hover:text-background-50"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#access"
            className="whitespace-nowrap rounded-full border border-primary-400 bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            立即进入
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          className={`flex h-10 w-10 items-center justify-center rounded-lg md:hidden ${
            scrolled ? "text-foreground-950" : "text-background-50"
          }`}
          onClick={() => setOpen((v) => !v)}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="mt-2">
              <a
                href="#access"
                onClick={() => setOpen(false)}
                className="block whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-medium text-background-50 hover:bg-primary-600"
              >
                立即进入
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}